// The short URL key is the last path segment, e.g. https://live.iprsapps.com/abc123 -> 'abc123'.
// The root path gives an empty key.
export function getKeyFromPath(pathname) {
    const trimmed = (pathname || '').replace(/^\/+|\/+$/g, '');
    return trimmed.substring(trimmed.lastIndexOf('/') + 1);
}

// Only follow http(s) URLs, never javascript: or data: URLs.
export function isRedirectURL(url) {
    return typeof url === 'string' && /^https?:\/\//i.test(url);
}
